import React, { useEffect, useContext } from 'react';
import ProptTypes                       from 'prop-types';
import { NovaContext }                  from '../../../ContextProviders/Nova/NovaContext';
import FixedAgentConnectionStep         from './FixedAgentConnectionStep';
import { makeStyles, createStyles }     from '@material-ui/core';
import HeadStepper                      from '../../Shared/Stepper/Stepper';
import Paper                            from '@material-ui/core/Paper';

const OrderStatusWatcher =   React.lazy(() => import('../../Shared/OrderStatusWatcher/OrderStatusWatcher'));

const useStyles = makeStyles(theme => createStyles({
    root: {
        maxWidth: 480,
        margin: '0 auto',
        [theme.breakpoints.up(800)]: {
            maxWidth: 800,
        }
    }
}));

const FixedAgentConnectionStepContainer = function FixedAgentConnectionStepContainer({ history, match }) {

    const { root } = useStyles();
    const { params: { UID } } = match;
    const {
        state
    } = useContext(NovaContext);

    const {
        emailNotAllowedToContinue
    } = state;

    useEffect(function emailNotAllowedEffect(){
        if(emailNotAllowedToContinue) {
            window.localStorage.clear();
            history.push(`/${UID}/`);
        }
    }, [
        emailNotAllowedToContinue,
        UID,
        history
    ]);

    return(
        <Paper
            className={root}
            elevation={6}>
            <OrderStatusWatcher
                UID={UID}
                history={history}
                match={match}>
                <HeadStepper
                    currentStep={4}/>
                <FixedAgentConnectionStep
                    match={match}
                />
            </OrderStatusWatcher>
        </Paper>
    );
};

FixedAgentConnectionStepContainer.propTypes = {
    history: ProptTypes.object.isRequired,
    match: ProptTypes.object.isRequired
};

export default FixedAgentConnectionStepContainer;
